export const UserRoleType = {
	Administrator: 'Administrator',
	Signer: 'Signer',
	Superuser: 'Superuser',
	User: 'User',
} as const;
export type UserRoleType = (typeof UserRoleType)[keyof typeof UserRoleType];
